import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";

// 👇 Import SurveyContext hook
import { useSurveyContext } from "../context/SurveyContext";

// Styled Components
const Container = styled.div`
  display: flex;
  justify-content: center;
  padding: 20px;
  background-color: #000;
  min-height: 81vh;
  box-sizing: border-box;
  padding-top: 120px;
`;

const ContentWrapper = styled.div`
  max-width: 600px;
  width: 100%;
  color: white;
`;

const Title = styled.h1`
  font-size: 24px;
  color: #ff372f;
  margin-bottom: 20px;
  text-align: center;

  @media (min-width: 768px) {
    font-size: 28px;
  }
`;

const SubTitle = styled.h2`
  font-size: 20px;
  color: #ff372f;
  margin-bottom: 20px;
  text-align: center;

  @media (min-width: 768px) {
    font-size: 20px;
  }
`;

const Description = styled.p`
  font-size: 15px;
  line-height: 1.5;
  margin-bottom: 25px;
  color: #e0e0e0;
  text-align: center;
`;

const Label = styled.label`
  font-size: 14px;
  color: #cccccc;
  display: block;
  margin-bottom: 5px;
  margin-top: 15px;
`;

const Input = styled.input`
  padding: 12px 10px;
  border-radius: 4px;
  border: none;
  width: 100%;
  margin-bottom: 10px;
  box-sizing: border-box;

  @media (max-width: 768px) {
    padding: 12px 14px;
    font-size: 14px;
  }
`;

const Button = styled.button`
  background-color: #ff372f;
  color: white;
  padding: 12px;
  font-size: 16px;
  border: none;
  border-radius: 4px;
  margin-top: 25px;
  width: 100%;
  cursor: pointer;
  &:disabled {
    background-color: #888;
    cursor: not-allowed;
  }
`;

const ErrorText = styled.p`
  color: #FF372F;
  font-size: 13px;
  text-align: left;
  margin-top: -5px;
  margin-bottom: 10px;
`;

const Welcome: React.FC = () => {
  const navigate = useNavigate();

  // 👇 Use context
  const { setSurveyData } = useSurveyContext();

  const [optionalEmail, setOptionalEmail] = useState("");
  const [projectNumber, setProjectNumber] = useState("");
  const [emailError, setEmailError] = useState("");

  const validateEmail = (email: string) => {
    if (!email) return true;
    const wspRegex = /^[a-zA-Z0-9._%+-]+@wsp\.com$/;
    return wspRegex.test(email);
  };

  const handleStartAssessment = () => {
    if (!validateEmail(optionalEmail)) {
      setEmailError("Please enter a valid WSP email.");
      return;
    }

    setEmailError("");

    // 👇 Update context before navigation
    setSurveyData((prev) => ({
      ...prev,
      optionalEmail,
      projectNumber,
    }));

    navigate("/WorkArrangementsTool");
  };

  return (
    <Container>
      <ContentWrapper>
        <Title>Welcome to Fatigue Risk Calculator</Title>
        <Description>
          This fatigue risk calculator may be completed by the worker or their
          People or Team Leader as per the SHEQ Fatigue Management Procedure to
          assist in managing potential fatigue risk. When completing the app, rate each of the factors based on your current personal circumstances. Each factor is point
          scored Low, Medium or High. On completion, each category will be
          totalled and compared against the risk rating score. Guidance
          resulting from this assessment should be discussed with your People or
          Team Leader where recommended.
          <br></br>
          <br></br>
          The final questionnaire results will be sent to your line manager and any additional project manager you specify.
        </Description>

         <SubTitle>Complete below section if you are on the project full time.</SubTitle>

         <Label>Enter the Project Number:</Label>
        <Input
          type="text"
          placeholder="Enter Project Number"
          value={projectNumber}
          onChange={(e) => setProjectNumber(e.target.value)}
        />
        <Label>Enter the Project Manager Email:</Label>
        <Input
          type="email"
          placeholder="Enter additional email (e.g., Project Manager Email)"
          value={optionalEmail}
          onChange={(e) => setOptionalEmail(e.target.value)}
        />
        {emailError && <ErrorText>{emailError}</ErrorText>}

       

        <Button title="Start Assessment" onClick={handleStartAssessment}>
          Start Assessment
        </Button>
      </ContentWrapper>
    </Container>
  );
};

export default Welcome;
